import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

function BusinessModels() {
   return (
      <section className="industries-bg-image">
         <div className="container">
            <h2 className="text-center cs-text-secondary tech_title section_heading_title mb-2">
               Business Models We Empower
            </h2>
            <p className="section_desc cs-text-secondary mb-0">
               We at Benzatine provide customized app solutions for various restaurant and hospitality business models. You could be operating a small cafe, a large restaurant chain, or a cloud kitchen – our skilled services assist you in streamlining operations, improving customer experience, and driving revenue.
            </p>
            <p className="in-icon-title res-food-title">
               Restaurant and Food Service Apps
            </p>
            <div className="in-bm-modal-section">
               <div className="in-bm-wrap">
                  <h3 className="in-bm-title">Cloud Kitchens</h3>
                  <p className="in-bm-sun-desc">Solutions for</p>
                  <p className="in-bm-sun-desc">operating kitchens</p>
                  <p className="in-bm-sun-desc">without dine-in.</p>
                  <svg
                     width="86"
                     height="80"
                     viewBox="0 0 86 80"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                     className="in-bm-top-icon"
                  >
                     <path
                        d="M75.0691 78.2725L64.1279 71.7972C62.1691 70.3934 61.1819 67.9959 61.5843 65.6198V58.8684L57.4819 54.7768C55.5694 52.8628 55.5694 49.7613 57.4819 47.8473C57.7097 47.619 57.9592 47.4134 58.2268 47.2332C60.1704 45.9448 62.7522 46.2015 64.4041 47.8473L70.1672 53.614M64.3387 28.6795L77.8707 40.6707C79.8869 43.4904 80.9707 46.8701 80.9702 50.3364V58.396C80.9669 60.7106 81.8817 62.9321 83.5138 64.5733L84.5713 65.6271M16.0175 53.614L21.7806 47.8473C23.4325 46.2015 26.0143 45.9448 27.9579 47.2332C28.2255 47.4134 28.4749 47.619 28.7028 47.8473C30.6152 49.7613 30.6152 52.8628 28.7028 54.7768L24.6149 58.8684V65.6053C25.0173 67.9813 24.0301 70.3789 22.0713 71.7826L11.1156 78.2725M1.60254 65.6053L2.65995 64.5515C4.29211 62.9103 5.20684 60.6888 5.20355 58.3742V50.3183C5.20307 46.8519 6.28686 43.4722 8.30312 40.6526L21.846 28.6795M64.4223 47.8473V11.412C64.4203 9.88165 63.1801 8.64152 61.6497 8.63952L50.5633 8.63952C50.5633 4.55759 47.2542 1.24854 43.1723 1.24854C39.0904 1.24854 35.7813 4.55759 35.7813 8.63952L24.6985 8.63952C23.1672 8.63952 21.9259 9.88082 21.9259 11.412V47.8473M24.6985 65.3255H61.6497M29.2006 20.2165H40.9739M53.9463 20.2165H57.3402M29.2006 28.6976H40.9739M53.9463 28.6976H57.3402M29.2006 39.1773H40.9739M53.9463 39.1773H57.3402"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>
               </div>
               <div className="in-bm-wrap">
                  <h3 className="in-bm-title">Restaurant Apps</h3>
                  <p className="in-bm-sun-desc">Apps for managing</p>
                  <p className="in-bm-sun-desc">single or multiple</p>
                  <p className="in-bm-sun-desc">restaurant chains.</p>
                  <svg
                     width="86"
                     className="in-bm-top-icon"
                     height="85"
                     viewBox="0 0 86 85"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M70.8842 53.7585L54.5324 70.1102M54.5324 53.7585L70.8842 70.1102M5.09207 41.0913L9.69962 47.9954C10.9156 49.8154 12.9614 50.9064 15.1502 50.9024H31.3929M1.81445 41.0913H37.9336M10.0085 41.0913C10.0159 26.3989 20.8371 13.9529 35.3858 11.9034C49.9346 9.85386 63.773 18.826 67.8391 32.9446M40.906 61.9343C40.906 73.9754 50.6672 83.7367 62.7083 83.7367C74.7494 83.7367 84.5106 73.9754 84.5106 61.9343C84.5106 49.8933 74.7494 40.132 62.7083 40.132C50.6672 40.132 40.906 49.8933 40.906 61.9343ZM34.5797 6.69094C34.579 9.4047 36.7787 11.605 39.4925 11.605C42.2063 11.605 44.406 9.4047 44.4053 6.69094C44.406 3.97717 42.2063 1.77686 39.4925 1.77686C36.7787 1.77686 34.579 3.97717 34.5797 6.69094Z"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>
               </div>
               <div className="in-bm-wrap">
                  <h3 className="in-bm-title">Delivery Agent Apps</h3>
                  <p className="in-bm-sun-desc">Apps for managing</p>
                  <p className="in-bm-sun-desc">food delivery</p>
                  <p className="in-bm-sun-desc">personnel.</p>
                  <svg
                     width="85"
                     className="in-bm-top-icon"
                     height="85"
                     viewBox="0 0 85 85"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M48.5909 65.466C53.608 65.466 57.6752 60.5856 57.6752 54.5649C57.6752 48.5442 53.608 43.6637 48.5909 43.6637C43.5738 43.6637 39.5066 48.5442 39.5066 54.5649C39.5066 60.5856 43.5738 65.466 48.5909 65.466ZM48.5909 65.466V83.6346M68.5763 83.6346V69.0998M68.5763 69.0998H83.1112C83.1112 61.8323 83.1112 50.9312 68.5763 43.6637V69.0998ZM29.3322 67.2829H6.80312C3.89614 67.2829 1.35254 64.7393 1.35254 61.8323V23.6783C1.35254 20.7713 3.89614 18.2277 6.80312 18.2277H61.3089C64.2159 18.2277 66.7595 20.7713 66.7595 23.6783V29.8556M64.9426 19.6812L54.7682 4.41958C53.6781 2.96609 52.2246 1.87598 50.4077 1.87598H18.0676C16.2508 1.87598 14.4339 2.96609 13.7072 4.41958L3.1694 19.6812M34.056 1.87598V18.2277"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>
               </div>
               <div className="in-bm-wrap">
                  <h3 className="in-bm-title">Reservation Apps</h3>
                  <p className="in-bm-sun-desc">Apps for booking</p>
                  <p className="in-bm-sun-desc">tables at</p>
                  <p className="in-bm-sun-desc">restaurants.</p>
                  <svg
                     width="85"
                     className="in-bm-top-icon"
                     height="85"
                     viewBox="0 0 85 85"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M7.79457 11.3853C6.13058 11.3853 4.53476 12.0463 3.35812 13.2229C2.18152 14.3995 1.52051 15.9954 1.52051 17.6593V77.263C1.52051 78.9269 2.18152 80.5228 3.35812 81.6994C4.53476 82.876 6.13058 83.537 7.79457 83.537H48.2582M20.3425 1.97363V20.7958M64.2611 1.97363V20.7958M20.3425 11.3853H51.7128M83.0834 48.0628V17.6593C83.0834 15.9954 82.4224 14.3995 81.2458 13.2229C80.0692 12.0463 78.4733 11.3853 76.8094 11.3853H64.2611M29.6048 65.4363C27.4467 66.3491 25.0539 66.5511 22.7732 66.0134C20.4924 65.4759 18.4419 64.2259 16.9189 62.445L15.3203 60.8466C14.6248 60.2884 14.1721 59.4828 14.0568 58.5988C13.9414 57.7147 14.1724 56.82 14.7014 56.102L19.8583 50.9454C20.5761 50.4163 21.4707 50.1852 22.3549 50.3008C23.2391 50.416 24.0445 50.8687 24.6027 51.5642C25.1608 52.2594 25.9662 52.7121 26.8504 52.8277C27.7346 52.9429 28.6292 52.7118 29.347 52.1831L37.598 43.932C38.127 43.2139 38.3581 42.3193 38.2426 41.4352C38.1274 40.5512 37.6746 39.7456 36.9791 39.1874C36.2836 38.6293 35.8309 37.8241 35.7157 36.94C35.6005 36.0555 35.8313 35.1611 36.3603 34.4432L41.5173 29.2863C42.235 28.7573 43.1296 28.5263 44.014 28.6417C44.8981 28.757 45.7033 29.2097 46.2615 29.9051L47.8603 31.5038C49.6343 33.0316 50.8792 35.0819 51.4166 37.3608C51.9541 39.6398 51.756 42.0301 50.8512 44.1896C45.6223 52.9098 38.3251 60.207 29.6048 65.4363ZM73.1416 51.9469H61.4355V61.8891H51.4933V73.5947H61.4355V83.5362H73.1416V73.5947H83.0827V61.8891H73.1416V51.9469Z"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>
               </div>
               <div className="in-bm-wrap">
                  <h3 className="in-bm-title">Catering Apps</h3>
                  <p className="in-bm-sun-desc">Applications for</p>
                  <p className="in-bm-sun-desc">managing catering</p>
                  <p className="in-bm-sun-desc">and events.</p>
                  <svg
                     width="84"
                     className="in-bm-top-icon"
                     height="86"
                     viewBox="0 0 84 86"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M26.3789 84.1044H58.5446M77.3091 11.7134C80.2712 11.7134 82.6725 14.1147 82.6725 17.0768V63.5411C82.6773 64.9664 82.1143 66.3349 81.1078 67.3441C80.1014 68.3533 78.7344 68.92 77.3091 68.919H7.61439C6.18975 68.9191 4.82372 68.3519 3.81805 67.3428C2.81238 66.3337 2.24983 64.9658 2.25466 63.5411V17.0768C2.25265 14.1153 4.65287 11.7134 7.61439 11.7134M32.7743 84.1044L36.6151 68.9009M52.1493 84.1044L48.312 68.9009M26.6296 24.3697V44.1989M56.4988 1.4082V44.1989M46.7314 1.4082V17.4801C46.7314 21.2011 51.0918 24.217 56.4915 24.217C61.884 24.217 66.2517 21.2011 66.2517 17.4801V1.4082M2.06934 53.3994H82.6725M17.6035 12.8908C17.6022 19.2315 21.6437 24.3726 26.6296 24.3726C31.6156 24.3726 35.6571 19.2315 35.6558 12.8908C35.6571 6.54997 31.6156 1.4089 26.6296 1.4089C21.6437 1.4089 17.6022 6.54997 17.6035 12.8908Z"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>
               </div>
            </div>
            <div className="in-bm-bottom-modal-section">
               <div className="in-bm-wrap">
                  <svg
                     width="86"
                     height="85"
                     className="in-bm-top-icon"
                     viewBox="0 0 86 85"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M18.4165 41.6078V51.6005M18.4165 62.5016V65.2269C18.4165 68.2372 20.8568 70.6775 23.867 70.6775L26.5923 70.6775M37.4935 70.6775H47.4862M57.0647 72.7923H83.9688M3.35469 24.7618L5.70935 29.3621C6.79781 31.4911 8.98687 32.8312 11.3779 32.8323H38.689C41.0827 32.8339 43.2752 31.4934 44.3648 29.3621L46.7195 24.7618M1.28711 24.7618H48.7944M6.45062 24.7618C6.45094 14.495 14.7739 6.17232 25.0407 6.17232M25.0407 6.17232C35.3075 6.17232 43.6305 14.495 43.6308 24.7618M25.0407 6.17232L25.0407 1.74951M62.1664 39.3658H78.5182C78.5182 39.3658 83.9687 39.3658 83.9687 44.8163V77.5198C83.9687 77.5198 83.9687 82.9704 78.5182 82.9704H62.1664C62.1664 82.9704 56.7159 82.9704 56.7159 77.5198V44.8163C56.7159 44.8163 56.7159 39.3658 62.1664 39.3658Z"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>

                  <h3 className="in-bm-title">Food Delivery Apps</h3>
                  <p className="in-bm-sun-desc">Applications for</p>
                  <p className="in-bm-sun-desc">ordering food online.</p>
               </div>
               <div className="in-bm-wrap">
                  <svg
                     width="65"
                     className="in-bm-top-icon"
                     height="87"
                     viewBox="0 0 65 87"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M13.6221 75.1505C13.1208 75.1505 12.7143 75.5564 12.7137 76.0577C12.713 76.5589 13.1184 76.966 13.6197 76.9673C14.1209 76.9687 14.5285 76.5638 14.5305 76.0625C14.5315 75.8213 14.4361 75.5897 14.2655 75.4191C14.0949 75.2485 13.8633 75.1531 13.6221 75.1541M22.7064 75.1505C22.2051 75.1505 21.7986 75.5564 21.798 76.0577C21.7973 76.5589 22.2027 76.966 22.704 76.9673C23.2052 76.9687 23.6128 76.5638 23.6148 76.0625C23.6158 75.8213 23.5204 75.5897 23.3498 75.4191C23.1792 75.2485 22.9476 75.1531 22.7064 75.1541M7.26308 66.9782C4.25281 66.9782 1.8125 69.4185 1.8125 72.4288V79.6962C1.8125 82.7065 4.25281 85.1468 7.26308 85.1468H58.1351C61.1454 85.1468 63.5857 82.7065 63.5857 79.6962V72.4288C63.5857 69.4185 61.1454 66.9782 58.1351 66.9782M7.26308 66.9782H58.1351M7.26308 66.9782C4.25281 66.9782 1.8125 64.5379 1.8125 61.5277V54.2602C1.8125 51.2499 4.25281 48.8096 7.26308 48.8096H58.1351C61.1454 48.8096 63.5857 51.2499 63.5857 54.2602V61.5277C63.5857 64.5379 61.1454 66.9782 58.1351 66.9782M13.6221 56.9819C13.1208 56.9819 12.7143 57.3879 12.7137 57.8891C12.713 58.3903 13.1184 58.7974 13.6197 58.7987C14.1209 58.8001 14.5285 58.3952 14.5305 57.8939C14.5315 57.6527 14.4361 57.4211 14.2655 57.2505C14.0949 57.0799 13.8633 56.9845 13.6221 56.9855M22.7064 56.9819C22.2051 56.9819 21.7986 57.3879 21.798 57.8891C21.7973 58.3903 22.2027 58.7974 22.704 58.7987C23.2052 58.8001 23.6128 58.3952 23.6148 57.8939C23.6158 57.6527 23.5204 57.4211 23.3498 57.2505C23.1792 57.0799 22.9476 56.9845 22.7064 56.9855M63.5857 24.9252C63.5249 21.3408 62.0081 17.9354 59.3842 15.4925C56.7604 13.0496 53.2555 11.7796 49.6758 11.9746C46.4617 5.55513 39.8781 1.52069 32.6991 1.5713C22.9251 1.4301 14.722 8.90479 13.9564 18.6498C11.0395 18.0045 7.98696 18.6987 5.63592 20.5418C3.28488 22.3849 1.88217 25.1835 1.8125 28.1701C1.8125 38.0611 12.5538 37.9085 12.5538 37.9085H51.5C51.5 37.9085 63.5857 36.3787 63.5857 24.9252Z"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>

                  <h3 className="in-bm-title">Aggregator Platforms</h3>
                  <p className="in-bm-sun-desc">Platforms that</p>
                  <p className="in-bm-sun-desc">consolidate various</p>
                  <p className="in-bm-sun-desc">food services.</p>
               </div>
               <div className="in-bm-wrap">
                  <svg
                     width="84"
                     className="in-bm-top-icon"
                     height="85"
                     viewBox="0 0 84 85"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M16.8495 17.4432H29.3079M16.8495 33.0163H44.881M69.7979 33.0163L51.1102 64.1624L29.3079 51.704L16.8495 70.3917M76.0272 82.8501H7.5056C7.5056 82.8501 1.27637 82.8501 1.27637 76.6209V8.09935C1.27637 8.09935 1.27637 1.87012 7.5056 1.87012H76.0272C76.0272 1.87012 82.2564 1.87012 82.2564 8.09935V76.6209C82.2564 76.6209 82.2564 82.8501 76.0272 82.8501Z"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>
                  <h3 className="in-bm-title">Management Systems</h3>
                  <p className="in-bm-sun-desc">Tools for overseeing</p>
                  <p className="in-bm-sun-desc">restaurant</p>
                  <p className="in-bm-sun-desc">operations.</p>
               </div>

               <div className="in-bm-wrap">
                  <svg
                     width="84"
                     className="in-bm-top-icon"
                     height="87"
                     viewBox="0 0 84 87"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M63.9255 20.3477L70.1901 26.6122C78.5476 18.2547 84.5614 5.47851 81.6762 2.59697L81.0731 3.18927L46.5891 37.6805M34.3289 14.0941L40.5971 20.3586C44.0569 23.8184 49.6663 23.8184 53.1261 20.3586C56.5859 16.8988 56.5859 11.2893 53.1261 7.82953L46.8652 1.57227M40.5971 7.82953L70.4953 37.7241M26.6545 36.1507C29.4916 33.3128 29.4916 28.7125 26.6545 25.8746L18.9365 18.1675C16.0981 15.328 11.495 15.328 8.65667 18.1675L4.44155 22.3935C0.792059 26.0555 0.216835 31.7774 3.06437 36.0926C15.5098 54.8256 31.5697 70.8855 50.3027 83.3309C54.621 86.1865 60.3521 85.6109 64.0164 81.9537L68.246 77.7277C71.0831 74.8898 71.0831 70.2895 68.246 67.4516L60.5389 59.7408C57.7006 56.9013 53.0975 56.9013 50.2591 59.7408L47.6901 62.3099C39.0715 55.2194 31.1614 47.3092 24.0709 38.6907L26.6545 36.1507Z"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>

                  <h3 className="in-bm-title">Hotel Management Apps</h3>
                  <p className="in-bm-sun-desc">Systems for</p>
                  <p className="in-bm-sun-desc">managing hotel and</p>
                  <p className="in-bm-sun-desc">resort operations.</p>
               </div>
               <div className="in-bm-wrap">
                  <svg
                     width="87"
                     className="in-bm-top-icon"
                     height="80"
                     viewBox="0 0 87 80"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M43.9059 78.5151H69.342V62.1634C69.342 61.16 68.5285 60.3465 67.5251 60.3465H43.9059M43.9059 78.5151V60.3465M43.9059 78.5151H18.4699V62.1634C18.4699 61.16 19.2833 60.3465 20.2868 60.3465H43.9059M56.624 60.3465V67.614M56.624 60.3465H31.1879M56.624 60.3465V43.9948C56.624 42.9914 55.8105 42.1779 54.8071 42.1779H33.0048C32.0014 42.1779 31.1879 42.9914 31.1879 43.9948V60.3465M31.1879 60.3465V67.614M43.9059 42.1779V49.4454M38.4554 16.7419H49.3565M2.11816 29.4599V74.8814C2.11816 76.8882 3.74504 78.5151 5.75188 78.5151H82.06C84.0668 78.5151 85.6937 76.8882 85.6937 74.8814V29.4599M2.11816 29.4599H85.6937M2.11816 29.4599C2.11816 29.4599 3.93502 2.20703 43.9059 2.20703C83.8768 2.20703 85.6937 29.4599 85.6937 29.4599"
                        stroke="#1F473E"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>

                  <h3 className="in-bm-title">Inventory Management</h3>
                  <p className="in-bm-sun-desc">Tools for tracking</p>
                  <p className="in-bm-sun-desc">supplies and</p>
                  <p className="in-bm-sun-desc">inventory.</p>
               </div>
            </div>
            <div className="d-md-none d-inline slider-column">
               <div className="model_train_slider container-fluid position-relative mb-3">
                  <Swiper
                     modules={[Navigation, Pagination, Autoplay]}
                     loop={true}
                     centeredSlides={true}
                     autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                     }}
                     speed={1000}
                     effect={'coverflow'}
                     slidesPerView={1}
                     pagination={{
                        el: '.fintach-pagination',
                        dynamicBullets: false,
                        clickable: true,
                        renderBullet: function (index, className) {
                           return `<span class="${className} custom-dark-bullet"></span>`
                        },
                     }}
                     navigation={{
                        nextEl: '.model_train_slider_custom_next_btn3',
                        prevEl: '.model_train_slider_custom_prev_btn3',
                     }}
                     breakpoints={{
                        320: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        768: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        1025: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        1200: {
                           slidesPerView: 2,
                           spaceBetween: 30,
                        },
                     }}
                     className="service-slider"
                  >
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="86"
                              height="80"
                              viewBox="0 0 86 80"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="in-bm-wrap-slider-icon"
                           >
                              <path
                                 d="M75.0691 78.2725L64.1279 71.7972C62.1691 70.3934 61.1819 67.9959 61.5843 65.6198V58.8684L57.4819 54.7768C55.5694 52.8628 55.5694 49.7613 57.4819 47.8473C57.7097 47.619 57.9592 47.4134 58.2268 47.2332C60.1704 45.9448 62.7522 46.2015 64.4041 47.8473L70.1672 53.614M64.3387 28.6795L77.8707 40.6707C79.8869 43.4904 80.9707 46.8701 80.9702 50.3364V58.396C80.9669 60.7106 81.8817 62.9321 83.5138 64.5733L84.5713 65.6271M16.0175 53.614L21.7806 47.8473C23.4325 46.2015 26.0143 45.9448 27.9579 47.2332C28.2255 47.4134 28.4749 47.619 28.7028 47.8473C30.6152 49.7613 30.6152 52.8628 28.7028 54.7768L24.6149 58.8684V65.6053C25.0173 67.9813 24.0301 70.3789 22.0713 71.7826L11.1156 78.2725M1.60254 65.6053L2.65995 64.5515C4.29211 62.9103 5.20684 60.6888 5.20355 58.3742V50.3183C5.20307 46.8519 6.28686 43.4722 8.30312 40.6526L21.846 28.6795M64.4223 47.8473V11.412C64.4203 9.88165 63.1801 8.64152 61.6497 8.63952L50.5633 8.63952C50.5633 4.55759 47.2542 1.24854 43.1723 1.24854C39.0904 1.24854 35.7813 4.55759 35.7813 8.63952L24.6985 8.63952C23.1672 8.63952 21.9259 9.88082 21.9259 11.412V47.8473M24.6985 65.3255H61.6497M29.2006 20.2165H40.9739M53.9463 20.2165H57.3402M29.2006 28.6976H40.9739M53.9463 28.6976H57.3402M29.2006 39.1773H40.9739M53.9463 39.1773H57.3402"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>
                           <h3 className="in-bm-title">Cloud Kitchens</h3>
                           <p className="in-bm-sun-desc">Solutions for</p>
                           <p className="in-bm-sun-desc">operating kitchens</p>
                           <p className="in-bm-sun-desc">without dine-in.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="86"
                              className="in-bm-wrap-slider-icon"
                              height="85"
                              viewBox="0 0 86 85"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M70.8842 53.7585L54.5324 70.1102M54.5324 53.7585L70.8842 70.1102M5.09207 41.0913L9.69962 47.9954C10.9156 49.8154 12.9614 50.9064 15.1502 50.9024H31.3929M1.81445 41.0913H37.9336M10.0085 41.0913C10.0159 26.3989 20.8371 13.9529 35.3858 11.9034C49.9346 9.85386 63.773 18.826 67.8391 32.9446M40.906 61.9343C40.906 73.9754 50.6672 83.7367 62.7083 83.7367C74.7494 83.7367 84.5106 73.9754 84.5106 61.9343C84.5106 49.8933 74.7494 40.132 62.7083 40.132C50.6672 40.132 40.906 49.8933 40.906 61.9343ZM34.5797 6.69094C34.579 9.4047 36.7787 11.605 39.4925 11.605C42.2063 11.605 44.406 9.4047 44.4053 6.69094C44.406 3.97717 42.2063 1.77686 39.4925 1.77686C36.7787 1.77686 34.579 3.97717 34.5797 6.69094Z"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>
                           <h3 className="in-bm-title">Restaurant Apps</h3>
                           <p className="in-bm-sun-desc">Apps for managing</p>
                           <p className="in-bm-sun-desc">single or multiple</p>
                           <p className="in-bm-sun-desc">restaurant chains.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="85"
                              className="in-bm-wrap-slider-icon"
                              height="85"
                              viewBox="0 0 85 85"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M48.5909 65.466C53.608 65.466 57.6752 60.5856 57.6752 54.5649C57.6752 48.5442 53.608 43.6637 48.5909 43.6637C43.5738 43.6637 39.5066 48.5442 39.5066 54.5649C39.5066 60.5856 43.5738 65.466 48.5909 65.466ZM48.5909 65.466V83.6346M68.5763 83.6346V69.0998M68.5763 69.0998H83.1112C83.1112 61.8323 83.1112 50.9312 68.5763 43.6637V69.0998ZM29.3322 67.2829H6.80312C3.89614 67.2829 1.35254 64.7393 1.35254 61.8323V23.6783C1.35254 20.7713 3.89614 18.2277 6.80312 18.2277H61.3089C64.2159 18.2277 66.7595 20.7713 66.7595 23.6783V29.8556M64.9426 19.6812L54.7682 4.41958C53.6781 2.96609 52.2246 1.87598 50.4077 1.87598H18.0676C16.2508 1.87598 14.4339 2.96609 13.7072 4.41958L3.1694 19.6812M34.056 1.87598V18.2277"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>
                           <h3 className="in-bm-title">Delivery Agent Apps</h3>
                           <p className="in-bm-sun-desc">Apps for managing</p>
                           <p className="in-bm-sun-desc">food delivery</p>
                           <p className="in-bm-sun-desc">personnel.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="85"
                              className="in-bm-wrap-slider-icon"
                              height="85"
                              viewBox="0 0 85 85"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M7.79457 11.3853C6.13058 11.3853 4.53476 12.0463 3.35812 13.2229C2.18152 14.3995 1.52051 15.9954 1.52051 17.6593V77.263C1.52051 78.9269 2.18152 80.5228 3.35812 81.6994C4.53476 82.876 6.13058 83.537 7.79457 83.537H48.2582M20.3425 1.97363V20.7958M64.2611 1.97363V20.7958M20.3425 11.3853H51.7128M83.0834 48.0628V17.6593C83.0834 15.9954 82.4224 14.3995 81.2458 13.2229C80.0692 12.0463 78.4733 11.3853 76.8094 11.3853H64.2611M29.6048 65.4363C27.4467 66.3491 25.0539 66.5511 22.7732 66.0134C20.4924 65.4759 18.4419 64.2259 16.9189 62.445L15.3203 60.8466C14.6248 60.2884 14.1721 59.4828 14.0568 58.5988C13.9414 57.7147 14.1724 56.82 14.7014 56.102L19.8583 50.9454C20.5761 50.4163 21.4707 50.1852 22.3549 50.3008C23.2391 50.416 24.0445 50.8687 24.6027 51.5642C25.1608 52.2594 25.9662 52.7121 26.8504 52.8277C27.7346 52.9429 28.6292 52.7118 29.347 52.1831L37.598 43.932C38.127 43.2139 38.3581 42.3193 38.2426 41.4352C38.1274 40.5512 37.6746 39.7456 36.9791 39.1874C36.2836 38.6293 35.8309 37.8241 35.7157 36.94C35.6005 36.0555 35.8313 35.1611 36.3603 34.4432L41.5173 29.2863C42.235 28.7573 43.1296 28.5263 44.014 28.6417C44.8981 28.757 45.7033 29.2097 46.2615 29.9051L47.8603 31.5038C49.6343 33.0316 50.8792 35.0819 51.4166 37.3608C51.9541 39.6398 51.756 42.0301 50.8512 44.1896C45.6223 52.9098 38.3251 60.207 29.6048 65.4363ZM73.1416 51.9469H61.4355V61.8891H51.4933V73.5947H61.4355V83.5362H73.1416V73.5947H83.0827V61.8891H73.1416V51.9469Z"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>
                           <h3 className="in-bm-title">Reservation Apps</h3>
                           <p className="in-bm-sun-desc">Apps for booking</p>
                           <p className="in-bm-sun-desc">tables at</p>
                           <p className="in-bm-sun-desc">restaurants.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="84"
                              className="in-bm-wrap-slider-icon"
                              height="86"
                              viewBox="0 0 84 86"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M26.3789 84.1044H58.5446M77.3091 11.7134C80.2712 11.7134 82.6725 14.1147 82.6725 17.0768V63.5411C82.6773 64.9664 82.1143 66.3349 81.1078 67.3441C80.1014 68.3533 78.7344 68.92 77.3091 68.919H7.61439C6.18975 68.9191 4.82372 68.3519 3.81805 67.3428C2.81238 66.3337 2.24983 64.9658 2.25466 63.5411V17.0768C2.25265 14.1153 4.65287 11.7134 7.61439 11.7134M32.7743 84.1044L36.6151 68.9009M52.1493 84.1044L48.312 68.9009M26.6296 24.3697V44.1989M56.4988 1.4082V44.1989M46.7314 1.4082V17.4801C46.7314 21.2011 51.0918 24.217 56.4915 24.217C61.884 24.217 66.2517 21.2011 66.2517 17.4801V1.4082M2.06934 53.3994H82.6725M17.6035 12.8908C17.6022 19.2315 21.6437 24.3726 26.6296 24.3726C31.6156 24.3726 35.6571 19.2315 35.6558 12.8908C35.6571 6.54997 31.6156 1.4089 26.6296 1.4089C21.6437 1.4089 17.6022 6.54997 17.6035 12.8908Z"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>
                           <h3 className="in-bm-title">Catering Apps</h3>
                           <p className="in-bm-sun-desc">Applications for</p>
                           <p className="in-bm-sun-desc">managing catering</p>
                           <p className="in-bm-sun-desc">and events.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="86"
                              height="85"
                              className="in-bm-wrap-slider-icon"
                              viewBox="0 0 86 85"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M18.4165 41.6078V51.6005M18.4165 62.5016V65.2269C18.4165 68.2372 20.8568 70.6775 23.867 70.6775L26.5923 70.6775M37.4935 70.6775H47.4862M57.0647 72.7923H83.9688M3.35469 24.7618L5.70935 29.3621C6.79781 31.4911 8.98687 32.8312 11.3779 32.8323H38.689C41.0827 32.8339 43.2752 31.4934 44.3648 29.3621L46.7195 24.7618M1.28711 24.7618H48.7944M6.45062 24.7618C6.45094 14.495 14.7739 6.17232 25.0407 6.17232M25.0407 6.17232C35.3075 6.17232 43.6305 14.495 43.6308 24.7618M25.0407 6.17232L25.0407 1.74951M62.1664 39.3658H78.5182C78.5182 39.3658 83.9687 39.3658 83.9687 44.8163V77.5198C83.9687 77.5198 83.9687 82.9704 78.5182 82.9704H62.1664C62.1664 82.9704 56.7159 82.9704 56.7159 77.5198V44.8163C56.7159 44.8163 56.7159 39.3658 62.1664 39.3658Z"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>

                           <h3 className="in-bm-title">Food Delivery Apps</h3>
                           <p className="in-bm-sun-desc">Applications for</p>
                           <p className="in-bm-sun-desc">
                              ordering food online.
                           </p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="86"
                              className="in-bm-wrap-slider-icon"
                              height="85"
                              viewBox="0 0 86 85"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M13.6221 75.1505C13.1208 75.1505 12.7143 75.5564 12.7137 76.0577C12.713 76.5589 13.1184 76.966 13.6197 76.9673C14.1209 76.9687 14.5285 76.5638 14.5305 76.0625C14.5315 75.8213 14.4361 75.5897 14.2655 75.4191C14.0949 75.2485 13.8633 75.1531 13.6221 75.1541M22.7064 75.1505C22.2051 75.1505 21.7986 75.5564 21.798 76.0577C21.7973 76.5589 22.2027 76.966 22.704 76.9673C23.2052 76.9687 23.6128 76.5638 23.6148 76.0625C23.6158 75.8213 23.5204 75.5897 23.3498 75.4191C23.1792 75.2485 22.9476 75.1531 22.7064 75.1541M7.26308 66.9782C4.25281 66.9782 1.8125 69.4185 1.8125 72.4288V79.6962C1.8125 82.7065 4.25281 85.1468 7.26308 85.1468H58.1351C61.1454 85.1468 63.5857 82.7065 63.5857 79.6962V72.4288C63.5857 69.4185 61.1454 66.9782 58.1351 66.9782M7.26308 66.9782H58.1351M7.26308 66.9782C4.25281 66.9782 1.8125 64.5379 1.8125 61.5277V54.2602C1.8125 51.2499 4.25281 48.8096 7.26308 48.8096H58.1351C61.1454 48.8096 63.5857 51.2499 63.5857 54.2602V61.5277C63.5857 64.5379 61.1454 66.9782 58.1351 66.9782M13.6221 56.9819C13.1208 56.9819 12.7143 57.3879 12.7137 57.8891C12.713 58.3903 13.1184 58.7974 13.6197 58.7987C14.1209 58.8001 14.5285 58.3952 14.5305 57.8939C14.5315 57.6527 14.4361 57.4211 14.2655 57.2505C14.0949 57.0799 13.8633 56.9845 13.6221 56.9855M22.7064 56.9819C22.2051 56.9819 21.7986 57.3879 21.798 57.8891C21.7973 58.3903 22.2027 58.7974 22.704 58.7987C23.2052 58.8001 23.6128 58.3952 23.6148 57.8939C23.6158 57.6527 23.5204 57.4211 23.3498 57.2505C23.1792 57.0799 22.9476 56.9845 22.7064 56.9855M63.5857 24.9252C63.5249 21.3408 62.0081 17.9354 59.3842 15.4925C56.7604 13.0496 53.2555 11.7796 49.6758 11.9746C46.4617 5.55513 39.8781 1.52069 32.6991 1.5713C22.9251 1.4301 14.722 8.90479 13.9564 18.6498C11.0395 18.0045 7.98696 18.6987 5.63592 20.5418C3.28488 22.3849 1.88217 25.1835 1.8125 28.1701C1.8125 38.0611 12.5538 37.9085 12.5538 37.9085H51.5C51.5 37.9085 63.5857 36.3787 63.5857 24.9252Z"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>

                           <h3 className="in-bm-title">Aggregator Platforms</h3>
                           <p className="in-bm-sun-desc">Platforms that</p>
                           <p className="in-bm-sun-desc">consolidate various</p>
                           <p className="in-bm-sun-desc">food services.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="84"
                              className="in-bm-wrap-slider-icon"
                              height="85"
                              viewBox="0 0 84 85"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M16.8495 17.4432H29.3079M16.8495 33.0163H44.881M69.7979 33.0163L51.1102 64.1624L29.3079 51.704L16.8495 70.3917M76.0272 82.8501H7.5056C7.5056 82.8501 1.27637 82.8501 1.27637 76.6209V8.09935C1.27637 8.09935 1.27637 1.87012 7.5056 1.87012H76.0272C76.0272 1.87012 82.2564 1.87012 82.2564 8.09935V76.6209C82.2564 76.6209 82.2564 82.8501 76.0272 82.8501Z"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>
                           <h3 className="in-bm-title">Management Systems</h3>
                           <p className="in-bm-sun-desc">
                              Tools for overseeing
                           </p>
                           <p className="in-bm-sun-desc">restaurant</p>
                           <p className="in-bm-sun-desc">operations.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="84"
                              className="in-bm-wrap-slider-icon"
                              height="87"
                              viewBox="0 0 84 87"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M63.9255 20.3477L70.1901 26.6122C78.5476 18.2547 84.5614 5.47851 81.6762 2.59697L81.0731 3.18927L46.5891 37.6805M34.3289 14.0941L40.5971 20.3586C44.0569 23.8184 49.6663 23.8184 53.1261 20.3586C56.5859 16.8988 56.5859 11.2893 53.1261 7.82953L46.8652 1.57227M40.5971 7.82953L70.4953 37.7241M26.6545 36.1507C29.4916 33.3128 29.4916 28.7125 26.6545 25.8746L18.9365 18.1675C16.0981 15.328 11.495 15.328 8.65667 18.1675L4.44155 22.3935C0.792059 26.0555 0.216835 31.7774 3.06437 36.0926C15.5098 54.8256 31.5697 70.8855 50.3027 83.3309C54.621 86.1865 60.3521 85.6109 64.0164 81.9537L68.246 77.7277C71.0831 74.8898 71.0831 70.2895 68.246 67.4516L60.5389 59.7408C57.7006 56.9013 53.0975 56.9013 50.2591 59.7408L47.6901 62.3099C39.0715 55.2194 31.1614 47.3092 24.0709 38.6907L26.6545 36.1507Z"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>

                           <h3 className="in-bm-title">
                              Hotel Management Apps
                           </h3>
                           <p className="in-bm-sun-desc">Systems for</p>
                           <p className="in-bm-sun-desc">managing hotel and</p>
                           <p className="in-bm-sun-desc">resort operations.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="in-bm-wrap">
                           <svg
                              width="87"
                              className="in-bm-wrap-slider-icon"
                              height="80"
                              viewBox="0 0 87 80"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M43.9059 78.5151H69.342V62.1634C69.342 61.16 68.5285 60.3465 67.5251 60.3465H43.9059M43.9059 78.5151V60.3465M43.9059 78.5151H18.4699V62.1634C18.4699 61.16 19.2833 60.3465 20.2868 60.3465H43.9059M56.624 60.3465V67.614M56.624 60.3465H31.1879M56.624 60.3465V43.9948C56.624 42.9914 55.8105 42.1779 54.8071 42.1779H33.0048C32.0014 42.1779 31.1879 42.9914 31.1879 43.9948V60.3465M31.1879 60.3465V67.614M43.9059 42.1779V49.4454M38.4554 16.7419H49.3565M2.11816 29.4599V74.8814C2.11816 76.8882 3.74504 78.5151 5.75188 78.5151H82.06C84.0668 78.5151 85.6937 76.8882 85.6937 74.8814V29.4599M2.11816 29.4599H85.6937M2.11816 29.4599C2.11816 29.4599 3.93502 2.20703 43.9059 2.20703C83.8768 2.20703 85.6937 29.4599 85.6937 29.4599"
                                 stroke="#1F473E"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              />
                           </svg>

                           <h3 className="in-bm-title">Inventory Management</h3>
                           <p className="in-bm-sun-desc">Tools for tracking</p>
                           <p className="in-bm-sun-desc">supplies and</p>
                           <p className="in-bm-sun-desc">inventory.</p>
                        </div>
                     </SwiperSlide>
                  </Swiper>
               </div>
               <div className="model_train_slider_custom_prev_btn3"></div>
               <div className="model_train_slider_custom_next_btn3"></div>
               <div className="d-xl-none d-flex align-items-center justify-content-center">
                  <span className="d-flex align-items-center justify-content-center fintach-pagination"></span>
               </div>
            </div>
         </div>
      </section>
   )
}

export default BusinessModels
